import { render } from "./ChatbotChoresEvents.vue?vue&type=template&id=4afceaad&scoped=true"
import script from "./ChatbotChoresEvents.vue?vue&type=script&lang=js"
export * from "./ChatbotChoresEvents.vue?vue&type=script&lang=js"

import "./ChatbotChoresEvents.vue?vue&type=style&index=0&id=4afceaad&scoped=true&lang=css"
import "./ChatbotChoresEvents.vue?vue&type=style&index=1&id=4afceaad&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afceaad"]])

export default __exports__